import React from 'react'
import styled from 'react-emotion'

const SubHeader = styled.p(props => `
  font-size: 1.2rem;
  line-height: 1.8rem;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  margin-bottom: 2rem;
  text-transform: ${props.uppercase ? 'uppercase': ''};
  text-align: ${props.align || 'left'};

  @media (min-width: 800px) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

`)

export default SubHeader



// WEBPACK FOOTER //
// ./src/components/section/SubHeader.js